import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { find } from "lodash"

import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ACTIONS
const requested = createAction("communication/requested")
const received = createAction("communication/received")
const failed = createAction("communication/failed")

const updatingMessage = createAction("communication/updatingMessage")
const updatedMessage = createAction("communication/updatedMessage")

// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  marketplace: [],
  manual: [],
  updatingId: null
}

const communicationReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state)
  },
  [received.type]: (state, action) => {
    setReceived(state)
    const payload = action.payload?.data || action.payload || {}
    const normalized = Object.entries(payload).flatMap(([category, items]) =>
      Array.isArray(items) ? items.map((item) => ({
        id: item.id,
        section: category.charAt(0).toUpperCase() + category.slice(1),
        type: item.mode,
        name: item.label,
        trigger_event: item.trigger_event,
        enabled: item.enabled,
        disabled: !item.enabled,
        subject: item.subject || "",
        body: item.body || ""
      })) : []
    )
    state.marketplace = normalized
    state.manual = normalized.map((item) => ({ ...item }))
  },
  [failed.type]: (state) => {
    setFailed(state)
    state.updatingId = null
  },
  [updatingMessage.type]: (state, action) => {
    state.updatingId = action.props.id
  },
  [updatedMessage.type]: (state, action) => {
    setReceived(state)
    state.updatingId = null
    const { id, enabled } = action.props
    ;[state.marketplace, state.manual].forEach((list) => {
      const item = find(list, ["id", id])
      if (item) {
        item.enabled = enabled
        item.disabled = !enabled
      }
    })
  }
})

export default communicationReducer

// THUNKS
export const fetchCommunicationMessages = () => (dispatch) =>
  dispatch(
    api({
      url: "/guide/settings/communication",
      onStart: requested.type,
      onSuccess: received.type,
      onError: failed.type
    })
  )

export const updateManualMessage = (id, enabled) => (dispatch) => {
  dispatch({ type: updatingMessage.type, props: { id } })
  return dispatch(
    api({
      url: `/guide/settings/communication/${id}`,
      method: "patch",
      data: { communication: { enabled } },
      onSuccess: updatedMessage.type,
      onError: failed.type,
      props: { id, enabled },
      showSuccessNotification: true
    })
  )
}

// SELECTORS
export const communicationSelector = (state) => state.communication
export const marketplaceMessagesSelector = (state) => state.communication.marketplace
export const manualMessagesSelector = (state) => state.communication.manual
export const communicationLoadingSelector = (state) => state.communication.loading
export const communicationUpdatingIdSelector = (state) => state.communication.updatingId
